export const CONTENT_MIN_LENGTH = 100;
